import React from "react";
import { styled } from "@mui/material/styles";
import { Card, Skeleton, Typography } from "@mui/material";
import { fShortenNumber } from "../../../Utils/formatNumber";
import Iconify from "../../../Components/Dashboard/Iconify";
import { useSelector } from "react-redux";
const getLGIState = (state) => state.usersReducer;


// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme, color }) => ({
    boxShadow: "none",
    textAlign: "center",
    padding: theme.spacing(3, 0),
    color: theme.palette.primary.darker,
    backgroundColor: color === "All LGIs" ? "rgba(0, 149, 255, 0.2)" : color === "Active LGIs" ? 'rgba(1, 108, 52, 0.19)' : "#FFE2E5",
    borderRadius: "16px",
}));

const IconWrapperStyle = styled("div")(({ theme, color }) => ({
    margin: "auto",
    display: "flex",
    borderRadius: "50%",
    alignItems: "center",
    width: theme.spacing(5),
    height: theme.spacing(5),
    justifyContent: "center",
    marginBottom: theme.spacing(2),
    color: "#FFF",
    backgroundColor: color === "All LGIs" ? "#0095FF" : color === "Active LGIs" ? "#016C34" : "#FA5A7D",
}));

// ----------------------------------------------------------------------

export default function CardAllUsers({ users }) {
    const {
        LGIUsers,
    } = useSelector(getLGIState);

    const TOTAL = LGIUsers?.meta?.dataReport?.totalLGIUsers || 0;
    const ACTIVE = LGIUsers?.meta?.dataReport?.totalEngagedLGIUsers || 0;
    const INACTIVE = LGIUsers?.meta?.dataReport?.totalDisEngagedLGIUsers || 0;
    return (
        <>
            {Object.keys(LGIUsers)?.length === 0 ? (
                <Skeleton variant="rounded" width="212px" height="156px" />
            ) : (
                <RootStyle color={users}>
                    <IconWrapperStyle color={users}>
                        <Iconify
                            rotate="180deg"
                            icon="ant-design:project-filled"
                            width={22}
                            height={22}
                        />
                    </IconWrapperStyle>
                    <Typography variant="h5" fontWeight={700} fontSize={"25px"}>
                        {users === "All LGIs" ? fShortenNumber(TOTAL) : users === "Active LGIs" ? fShortenNumber(ACTIVE) : fShortenNumber(INACTIVE)}
                    </Typography>
                    <Typography
                        variant="subtitle2"
                        sx={{ opacity: 0.72, fontSize: "12px" }}
                    >
                        {users ?? ''}
                    </Typography>
                </RootStyle>
            )}
        </>
    );
}
